import FormattedMessage from 'I18n/components/FormattedMessage';
import { ApprovalOperation, ApprovalTypes } from 'ui-product-approvals-common';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalOperationI18n = ({
  approvalOperation,
  approvalType
}) => {
  switch (approvalOperation) {
    case ApprovalOperation.REQUEST:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.REQUEST"
        });
      }
    case ApprovalOperation.RECALL:
    case ApprovalOperation.CANCEL:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.CANCEL"
        });
      }
    case ApprovalOperation.APPROVE:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.APPROVE"
        });
      }
    case ApprovalOperation.REJECT:
      {
        if (approvalType === ApprovalTypes.QUOTE) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "productApprovals.modal.action.REQUEST_CHANGES"
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.REJECT"
        });
      }
    case ApprovalOperation.REQUEST_CHANGES:
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.modal.action.REQUEST_CHANGES"
        });
      }
    default:
      return unreachableFallback(approvalOperation, /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.unhandled.approvalOperation"
      }));
  }
};